// extracted by mini-css-extract-plugin
export default {"faqsContainer":"FAQ_faqsContainer__GpT5f","faqItem":"FAQ_faqItem__pLd7n","accordionHeader":"FAQ_accordionHeader__ae2mL","accordionBody":"FAQ_accordionBody__6pKpd"};